/**
 * Feature flags convention: go/frontend-feature-flags. Please ensure integration tests are still working afterwards.
 */
import { fg } from '@atlassian/jira-feature-gating';

// Add your feature flag name as a constant
const ERROR_TRACKING_ENABLED = 'fe_platform_error_tracking_enabled_sentry';

const UIF_STATSIG_EXPOSURES_UPDATES = 'jsw.perf.uif.statsig-exposures-update';

// Add your feature flag constant to this list so that it can be picked up by cypress tests and storybook
export const backlogFeatureFlagNames: string[] = [
	ERROR_TRACKING_ENABLED,
	UIF_STATSIG_EXPOSURES_UPDATES,
	'jsw-backlog-main-component-refactor',
];

// eslint-disable-next-line jira/ff/inline-usage
export const isViewSettingAsPanelExpEnabledWithNoExposure = () =>
	fg('jira_view_settings_additional_fields');
